import client from './client';

export const getModules = async () => {
  const response = await client.get('/api/modules');
  return response.data;
};
